import React from "react";

// --------------------------------------------------

export default () => <h1>Not Found</h1>;


// WEBPACK FOOTER //
// ./src/components/NotFound.js